<template>
    <div class="navigator">
        <filters v-if="showFilters()" :value="filters" :on-value-changed="(value) => onFiltersChanged(value)" />

        <!--<div>{{ filters }}</div>-->
      
        
        <ul v-if="currStage < 4" class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li v-for="stage in stages" :key="stage.id" class="nav-item" role="presentation">
            <button 
              :class="'nav-link option-tab' + (stage.Index == currStage ? ' active' : '')" 
              :ref="'pill_' + stage.Index" 
              :id="'pill_' + stage.Index" 
              :value="stage.Index"
              @click.prevent="(e) => tabButtonClick(e)"
              data-bs-toggle="pill" 
              :data-bs-target="'#tab_' + stage.Index" 
              type="button" 
              role="tab" 
              :aria-controls="'tab_' + stage.Index" v-text="getTabName(stage)"></button>
          </li>
        </ul>
        <h6 class="summary" v-if="currStage == 4">{{ value.Summary }}</h6>
        <div class="tab-content" id="pills-tabContent">
          <div v-for="stage in stages" :key="stage.Id" :class="'tab-pane show' + (stage.Index == currStage ? ' active' : '')" :id="'tab_' + stage.Index" role="tabpanel" :aria-labelledby="'pill_' + stage.Index" :tabindex="stage.Index">
            <navigator-stage 
              :template-data="stage" 
              :on-value-changed="(stage,schema,selection,caption) => select(stage,schema,selection,caption)"
              :on-submitted="submit"
              :on-accepted="accept"
              :quote-id="quoteId"
            />    
          </div>
        </div>
        
        <!--
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Home</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Profile</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Contact</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-disabled-tab" data-bs-toggle="pill" data-bs-target="#pills-disabled" type="button" role="tab" aria-controls="pills-disabled" aria-selected="false" disabled>Disabled</button>
          </li>
        </ul>

        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">Tab 1</div>
          <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">Tab 2</div>
          <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">Tab 3</div>
          <div class="tab-pane fade" id="pills-disabled" role="tabpanel" aria-labelledby="pills-disabled-tab" tabindex="0">Tab 4</div>
        </div>
        -->

        <!--
        <DxTabPanel v-if="stages.length" 
            @content-ready="onTabContentReady"
            :items="stages"
            class="tab-panel"
            item-title-template="titleTemplate"
            item-template="itemTemplate"
            :animation-enabled="true"   
            :defer-rendering="false"         
            :repaint-changes-only="false"
            :scrolling-enabled="true"
            :scoll-content="true"
        >
         <template #titleTemplate="{ data: stage }">
            <div>
              <span>{{ stage.Caption }}</span>
            </div>
          </template>
          <template #itemTemplate="{ data: stage }">         
            <navigator-stage 
              :template-data="stage" 
              :on-value-changed="(stage,schema,selection,caption) => select(stage,schema,selection,caption)"
              :on-submitted="submit"
              :on-accepted="accept"
            />   
          </template>
        </DxTabPanel>-->
    </div>
</template>

<script>
    //import DxTabPanel from 'devextreme-vue/tab-panel';
    import Filters from './Filters.vue';
    import NavigatorStage from './NavigatorStage.vue';
    import { DxLoadPanel } from 'devextreme-vue/load-panel';
  
    export default {
        name: 'Navigator',
        components: {
            //DxTabPanel,
            Filters,
            NavigatorStage,
            DxLoadPanel
        },
        data() {
            return {   
                contactId: 0,
                organisationId: 0,  
                quoteId: 0,
                filters: {},
                schemas: [],
                stages: [],
                options: null,
                loading: false,
                currStage: 0,
                initialised: false
            };
        },
        props: { 
            value: {
                default: () => null
            },
            onValueChanged: {
                type: Function,
                default: () => function() {}
            },
            onSubmitted: {
              type: Function,
              default: () => function() {}
            },
            onAccepted: {
              type: Function,
              default: () => function() {}
            }
        },
        created: function () {          
            this.contactId = localStorage.getItem('contactId');
            this.organisationId = localStorage.getItem('organisationId');
            this.quoteId = this.$route.params.id;

            //var _this = this;
            //this.getFilters((data) => {   
            //  _this.filters = data;
            //});            
            
            /*
            this.worker = new Worker(new URL('@/worker.js',import.meta.url));
            this.worker.onmessage = ({ data: { answer } }) => {
              console.log(answer);
            };
            this.worker.postMessage({ question: '?'});
            */
            //console.log(VueWorker);
            this.init();
        },
        computed: {
          editable() {
            var acceptedQuoteStatusId = this.getSetting('AcceptedQuoteStatusId');
       
            return this.value && this.value.StatusId != acceptedQuoteStatusId;
          }
        },
        watch: {
          value: function() {           
            
            //this.init();
            var _this = this;

            if(this.value && this.value.Options) {
              
              //console.log("watch(value)");
              
              var options = this.value.Options;
              if(typeof options === 'string') {
                options = JSON.parse(options);              
              }
                            
              if(this.initialised)
                this.applyOptions(options,() =>
                {
                  //console.log(_this.currStage);
                  //if(_this.tabPanel) {
                  //  _this.tabPanel.option("selectedIndex", _this.currStage);       
                  //}
                  _this.selectTab(_this.currStage);
                })
              else
                this.options = options;
              
              /*
              this.options = options;
              this.init();
              */
            }
          }   
        },
        mounted: function () {                       
           
        },
        methods: {
      
          init() {
            //console.log("init");

            this.schemas = [];
            this.stages = [];
            this.currStage = 0;
            //this.options = null;
            this.loading = true;
            this.initialised = false;

            var _this = this;

            this.getFilters((filters) => {  
              var _filters = {};
              if(filters) {
                filters.forEach(filter => {
                  _filters[filter.Key] = filter.Value;
                });
              }
            
              this.getSchemas((data) => {
                this.buildSchemaTree(data);            

                if(this.quoteId == ':id') {      
                  this.initStage(0, () => { 
                    _this.loading = false;
                  });   
                } else {
                  if(_this.options) 
                      _this.applyOptions(_this.options, () =>
                      {
                        //console.log(_this.currStage);
                        //if(_this.tabPanel) {
                         // _this.tabPanel.option("selectedIndex", _this.currStage);       
                        //}
                        _this.selectTab(_this.currStage);
                      });  
                    _this.options = null;
                }
              
                _this.initialised = true;    
                _this.loading = false;          
              });
            });
          },
          buildSchemaTree(schemas) {
            //console.log("buildSchemaTree");
            
            this.schemas = [];
            this.stages = [];

            schemas.forEach(schema => {
              if(!this.schemas.find(s => s.ParentId == schema.ParentId )) {
                var node = { 
                  Id: schema.Id, 
                  Description: schema.Description,
                  Caption: schema.Caption, 
                  ParentId: schema.ParentId, 
                  Independent: schema.Independent 
                };
                node.children = schemas.filter(s => s.ParentId == schema.ParentId);
                    
                this.schemas.push(node);
              }
            });               

            //console.log(schemas);
          },
          initStage(index, callback) {
            //console.log("initStage");

            var schema = this.schemas[index];
      
            if(!schema)
              return;

            this.currStage = index;     
            //this.tabPanel.beginUpdate();
            
            //this.stages.splice(index);
                        
            var promises = [];    
            var modelId = null;   
          
            schema.children.forEach(child => {
              var path = this.apiUrl + "datasources/" + child.DataSourceId + "/data";
           
              if(index > 0 && !child.Independent) {
                var prevStage = this.stages[index-1];
                modelId = prevStage.modelId;
              
                if(prevStage && prevStage.data.length) {
                  path += '/' + prevStage.data[0].Selection;
                }
              }

              var filters = this.filters;

              if([56,57].includes(child.DataSourceId)) {
                filters = this.organisationId;
              }

              promises.push(
                this.$http.post(path,filters,
                {
                  headers: this.getHeaders()
                })
              );
            });

            var _this = this;

            this.loading = true;

            Promise.all(promises).then(function(values) {

              var data = values.map(v => v.data);
             
              for(var i=0; i<schema.children.length; ++i) {               
                schema.children[i].Options = data[i];
              }
         
              var lastStage = index == (_this.schemas.length-1);

              var stage = {};
              stage.Index = index;

              if(!lastStage) {
                stage.Caption = schema.Description;
                stage.Description = schema.Description;
              } else {
                var prevSchema = _this.schemas[index-1];          
                stage.Caption = prevSchema.Caption;
              }
             
              stage.modelId = modelId;
              stage.data = schema.children;
              stage.showSubmitButton = lastStage;
              stage.disabled = !_this.editable;

              if(_this.tabPanel) {
                _this.tabPanel.beginUpdate();
              }

              _this.stages.splice(index);
              _this.stages.push(stage);   
             
              //if(_this.tabPanel) {
              //  _this.tabPanel.endUpdate();
              //  _this.tabPanel.repaint();
              //}

              _this.loading = false;

              if(callback)
                callback();
            });
          },
          applyOptions(options, callback) {
            //console.log("applyOptions");

            var index = 0;
            var promises = [];       
            var prevSelection = null;
            var _this = this;

            var stages = [];

            //var data = [];

            //console.log(this.schemas);
            //console.log(options);

            var modelId;

            this.schemas.forEach(schema => {

              schema.children.forEach(child => {
                var path = this.apiUrl + "datasources/" + child.DataSourceId + "/data";
                if(prevSelection != null && !child.Independent) 
                  path += '/' + prevSelection;
            
                //data.push({ id: child.DataSourceId, param: prevSelection });

                var filters = this.filters;

                if([56,57].includes(child.DataSourceId)) {
                  filters = this.organisationId;
                }

                promises.push( 
                  this.$http.post(path,filters,
                  {
                    headers: this.getHeaders(),
                    schema: child
                  }));

                var option = options.find(o => o.DataSourceId == child.DataSourceId);
              
                if(option && option.Selection) {                   
                                        
                    child.Selection = option.Selection;
                    
                    if(child.DataSourceId == 34) 
                      modelId = option.Selection;
                      
                    if(child.Id == schema.Id)
                      prevSelection = option.Selection;
                    if(option.Summary) {
                      schema.Summary = option.Summary;
                      child.Summary = option.Summary;
                    }
                  }
              });
             
              var stage = {};
              stage.Index = index;
              stage.Caption = schema.Summary ?? schema.Description;
              stage.Description = schema.Description;
              stage.data = schema.children;
              stage.disabled = !_this.editable;
              if(modelId)
                stage.modelId = modelId;
              stages.push(stage);

              index++;
            });
             
            //this.post(this.apiUrl + "datasources/bulk", data, (response) => {
            //  console.log(response);
            //});

            this.currStage = index - 1;
          
            Promise.all(promises).then(function(values) {  
               
                _this.schemas.forEach(schema => {
                  schema.children.forEach(child => {
                    
                    var value = values.find(v => v.config.schema.Id == child.Id);                    
                    child.Options = value.data;   
                    
                    if(child.DataSourceId == 57) {

                      //console.log(child.Selection);

                      if(child.Selection) {
                        child.Selection.forEach(s => {
                          
                          var childOptionExists = child.Options.find(o => o.KeyValue == s.value);
                          if(!childOptionExists) {
                          //console.log(child.Selection);
                            //console.log(s);

                            //console.log(child.Options);

                            child.Options.push({ DataSourceId: 57, KeyValue: s.value, code: s.value, description: s.description, selected: true, optional: false });
                          }
                        });
                      }
                      
                      //console.log(child.Options);
                    }                   
                  });
                });

              _this.stages = stages;
              _this.currStage = index-1;
          
              _this.selectTab(_this.currStage);
              
              _this.loading = false;

              if(callback)
                callback();
            });
          },
          select(stage,schema,selection,caption) { 
            //console.log("select(" + stage.Index + ")");
            
            if(caption) {
              stage.Caption = caption.trim();
              schema.Summary = stage.Caption;
            }
            
            schema.Selection = selection;
            
            if(schema.DataSource.Id == 34)
                stage.modelId = selection;
          
            this.onValueChanged(this.extractOptions());

            var nextSchema = this.schemas[stage.Index+1];
            
            if(nextSchema) {              
              this.initStage(stage.Index+1, () =>
              {
                //this.tabPanel.option("selectedIndex", this.currStage);
                this.selectTab(this.currStage);       
              });
            } else {
              //this.tabPanel.option("selectedIndex", this.currStage);       
              this.selectTab(this.currStage);       
            }
          },
          tabButtonClick(e) {
            //console.log(e.srcElement.value);

            //var button = this.$refs[e.srcElement.id];
            //console.log(button);
            this.initStage(e.srcElement.value);
          },
          selectTab(index) {
            
            /*
            var button = this.$refs['pill_' + index];
            if(button) {
              console.log
              button = button[0];
              console.log(button);
              button.click();
            }
            //  button.click();
            */
          },
          getTabName(stage) {
            //console.log(stage);
            return stage.Caption;
          },
          extractOptions() {
            var options = [];
            var _this = this;

            this.schemas.forEach(schema => {
              schema.children.forEach(child => {
                if(child.Selection) {
                  options.push({
                    DataSourceId: child.DataSourceId,
                    Description: child.Description,
                    Summary: child.Summary,
                    Selection: JSON.parse(JSON.stringify(child.Selection))
                  });
                }
              });
            });         
            
            //console.log(options);

            return options;
          },
          submit(destSchema) {
            this.onSubmitted(destSchema);
          },  
          accept(data) {
            this.onAccepted(data);
          },
          isLoading() {
            return this.loading;
          },
          showFilters() {
            return !this.loading && this.initialised && !this.isLastStage();
          },
          isLastStage() {
            return this.currStage == (this.schemas.length - 1);
          },
          onFiltersChanged(value) {
            //console.log("onFiltersChanged");
            
            var filters = JSON.parse(JSON.stringify(this.filters));
            value = JSON.parse(JSON.stringify(value));
            
            if(this.objectEquals(filters,value))
              return;

            this.filters = value;

            this.initStage(this.currStage);
          }
          /*
          close(stage) {
            this.stages.splice(stage.index);
            this.currStage = stage.index - 1;
              
            // this.tabPanel.option("selectedIndex", this.currStage);
            this.tabPanel.repaint();
          },
          showCloseButton(stage) {
            return stage !== this.stages[0];
          }*/
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.navigator {
  padding:10px;
  background: #eeeeee;
  border-radius: 10px;
}
.navigator-option {
  background: white;
}
div.dx-tabs.dx-widget {
  background-color: #eeeeee!important;
}
.dx-tabpanel > .dx-tabpanel-tabs .dx-tabs,
.dx-tabpanel > .dx-tabpanel-tabs .dx-tabs .dx-tab {
  color: #eeeeee;
}

.dx-multiview-wrapper {
  border: transparent!important;
}

.nav-link.option-tab {
  margin-right: 5px;
}

.nav-link.option-tab.active {
  opacity: 0.6;
}


/*
.dx-tabs .dx-tabs-wrapper .dx-item.dx-tab {
  width: auto;
  padding-left: 20px;
}
.dx-tab-content .dx-icon.dx-icon-close {
  display: inline-block;
  opacity: 0.6;
  margin-right: 0;
  margin-left: 7px;
  font-size: 18px;
}
*/
.tab-panel {
  min-width: 1024px;
}

.dx-empty-message {  
  visibility: hidden;  
}  

h6.summary {
  padding-left: 5px;
}

.dx-datagrid .dx-row > td.desc-column {
    padding: 0!important;
}

.dx-datagrid .dx-row > td {
    padding: 0px!important;
    line-height: 25px!important;
    overflow: visible!important;
    text-wrap: wrap!important;
}

@media (max-width: 992px) {
   .tab-panel {
    min-width: unset;
   }
   .navigator {
    padding: 0px;
   }
   .dx-tabs-wrapper {
    display: grid!important;
   }
   /*
   .dx-datagrid .dx-row > td {
    padding: 0px!important;
    line-height: 25px!important;
    overflow: visible!important;
    text-wrap: wrap!important;
   }*/
}

</style>

